module.exports = __webpack_public_path__ + "media/packs/images/partners/back_alive_bg-01fd4e1284dce9c69fb2f298b6573d3d.jpg";